import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGameQuery } from "../settings/Settings.state";
import { Refresher, SidebarLayout } from "../common";
import { Row } from "../App.styles";
import ReelsPreview from "./ReelsPreview";
import ReelsForm from "./ReelsForm";
import ReelsPlaceholder from "./ReelsPlaceholder";
import { withPlaceholder } from "../common";

/**
 * The main Reels dashboard component.
 * Displays either the premium Reels preview (if the user hasn't unlocked the feature) 
 * or the active Reels configuration form (if unlocked).
 * 
 * @returns {React.ReactElement} The rendered Reels dashboard.
 */
const Reels = () => {
  const { t } = useTranslation();
  const { game_id } = useParams();
  const [{ reels_enabled }] = useGameQuery(game_id);

  return (
    <Row>
      <SidebarLayout message={t("Game, Challenge, and Team Reels Automated")}>
        {!reels_enabled && <ReelsPreview />}
        {reels_enabled && <ReelsForm />}
      </SidebarLayout>
      {/* Reel events are instant updates, so we don't need listeners */}
      <Refresher />
    </Row>
  );
};

export default withPlaceholder(Reels, ReelsPlaceholder);
